import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card p-3 mb-4" }
const _hoisted_2 = { class: "row g-2 align-items-end" }
const _hoisted_3 = { class: "col-md-4 col-sm-6" }
const _hoisted_4 = ["label"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.governorateId) = $event)),
          class: "form-select form-select-sm form-select-solid"
        }, [
          _createElementVNode("option", {
            label: _ctx.translate('selectArea'),
            disabled: "",
            value: ""
          }, null, 8, _hoisted_4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.govs, (gov) => {
            return (_openBlock(), _createElementBlock("option", {
              key: gov.id,
              value: gov.id
            }, _toDisplayString(gov.titleAr), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selectedItems.governorateId]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-light me-1",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ])
    ])
  ]))
}